"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
require("core-js/modules/es6.function.name");
var render = exports.render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "app-container"
  }, [_c("div", {
    staticClass: "filter-container"
  }, [_c("el-input", {
    staticClass: "filter-item",
    staticStyle: {
      width: "130px"
    },
    attrs: {
      placeholder: "ID",
      clearable: ""
    },
    model: {
      value: _vm.listQuery.brokerId,
      callback: function callback($$v) {
        _vm.$set(_vm.listQuery, "brokerId", $$v);
      },
      expression: "listQuery.brokerId"
    }
  }), _vm._v(" "), _c("el-input", {
    staticClass: "filter-item",
    staticStyle: {
      width: "130px"
    },
    attrs: {
      placeholder: _vm.$t("table.invitationCode"),
      clearable: ""
    },
    model: {
      value: _vm.listQuery.authCode,
      callback: function callback($$v) {
        _vm.$set(_vm.listQuery, "authCode", $$v);
      },
      expression: "listQuery.authCode"
    }
  }), _vm._v(" "), _c("el-input", {
    staticClass: "filter-item",
    staticStyle: {
      width: "130px"
    },
    attrs: {
      placeholder: _vm.$t("table.nickName"),
      clearable: ""
    },
    model: {
      value: _vm.listQuery.name,
      callback: function callback($$v) {
        _vm.$set(_vm.listQuery, "name", $$v);
      },
      expression: "listQuery.name"
    }
  }), _vm._v(" "), _c("el-select", {
    staticClass: "filter-item",
    staticStyle: {
      width: "130px"
    },
    attrs: {
      placeholder: "地区",
      clearable: ""
    },
    model: {
      value: _vm.listQuery.area_code,
      callback: function callback($$v) {
        _vm.$set(_vm.listQuery, "area_code", $$v);
      },
      expression: "listQuery.area_code"
    }
  }, _vm._l(_vm.areaCodeList, function (item) {
    return _c("el-option", {
      key: item.area_code,
      attrs: {
        label: item.area_code,
        value: item.area_code
      }
    });
  }), 1), _vm._v(" "), _c("el-input", {
    staticClass: "filter-item",
    staticStyle: {
      width: "120px"
    },
    attrs: {
      placeholder: _vm.$t("table.city"),
      clearable: ""
    },
    model: {
      value: _vm.listQuery.city_name,
      callback: function callback($$v) {
        _vm.$set(_vm.listQuery, "city_name", $$v);
      },
      expression: "listQuery.city_name"
    }
  }), _vm._v(" "), _c("el-input", {
    staticClass: "filter-item",
    staticStyle: {
      width: "120px"
    },
    attrs: {
      placeholder: _vm.$t("table.countryCode"),
      clearable: ""
    },
    model: {
      value: _vm.listQuery.country_code,
      callback: function callback($$v) {
        _vm.$set(_vm.listQuery, "country_code", $$v);
      },
      expression: "listQuery.country_code"
    }
  }), _vm._v(" "), _c("el-select", {
    staticClass: "filter-item",
    staticStyle: {
      width: "110px"
    },
    attrs: {
      placeholder: _vm.$t("table.status"),
      clearable: ""
    },
    model: {
      value: _vm.listQuery.status,
      callback: function callback($$v) {
        _vm.$set(_vm.listQuery, "status", $$v);
      },
      expression: "listQuery.status"
    }
  }, [_c("el-option", {
    attrs: {
      label: "正常",
      value: 1
    }
  }), _vm._v(" "), _c("el-option", {
    attrs: {
      label: "停用",
      value: 2
    }
  })], 1), _vm._v(" "), _vm.isAdminRole ? _c("el-input", {
    staticClass: "filter-item",
    staticStyle: {
      width: "130px"
    },
    attrs: {
      placeholder: "BD ID",
      clearable: ""
    },
    model: {
      value: _vm.listQuery.bd_id,
      callback: function callback($$v) {
        _vm.$set(_vm.listQuery, "bd_id", $$v);
      },
      expression: "listQuery.bd_id"
    }
  }) : _vm._e(), _vm._v(" "), _c("el-date-picker", {
    staticClass: "filter-item",
    attrs: {
      type: "datetimerange",
      "range-separator": "-",
      "start-placeholder": _vm.$t("form.startDate"),
      "end-placeholder": _vm.$t("form.endDate")
    },
    model: {
      value: _vm.times,
      callback: function callback($$v) {
        _vm.times = $$v;
      },
      expression: "times"
    }
  }), _vm._v(" "), _c("el-button", {
    directives: [{
      name: "waves",
      rawName: "v-waves"
    }],
    staticClass: "filter-item",
    attrs: {
      type: "primary",
      icon: "el-icon-search"
    },
    on: {
      click: _vm.handleFilter
    }
  }, [_vm._v(_vm._s(_vm.$t("table.search")))]), _vm._v(" "), _vm.canEditBroker ? _c("el-button", {
    directives: [{
      name: "waves",
      rawName: "v-waves"
    }],
    staticClass: "filter-item",
    attrs: {
      type: "primary",
      icon: "el-icon-plus"
    },
    on: {
      click: function click($event) {
        return _vm.handleEdit(null);
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("table.add")))]) : _vm._e()], 1), _vm._v(" "), _c("el-table", {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: _vm.listLoading,
      expression: "listLoading"
    }],
    staticStyle: {
      width: "100%"
    },
    attrs: {
      data: _vm.list,
      border: "",
      fit: "",
      "highlight-current-row": ""
    }
  }, [_c("el-table-column", {
    attrs: {
      align: "center",
      type: "index",
      width: "50",
      label: _vm.$t("table.sequence")
    }
  }), _vm._v(" "), _c("el-table-column", {
    attrs: {
      align: "center",
      prop: "broker_id",
      label: "ID"
    }
  }), _vm._v(" "), _c("el-table-column", {
    attrs: {
      align: "center",
      prop: "auth_code",
      label: _vm.$t("table.invitationCode")
    }
  }), _vm._v(" "), _c("el-table-column", {
    attrs: {
      align: "center",
      prop: "name",
      label: _vm.$t("table.name")
    }
  }), _vm._v(" "), _c("el-table-column", {
    attrs: {
      align: "center",
      prop: "anchorCount",
      label: _vm.$t("table.anchorCount")
    }
  }), _vm._v(" "), !_vm.isBdRole ? _c("el-table-column", {
    attrs: {
      align: "center",
      prop: "broker_username",
      label: _vm.$t("table.loginID")
    }
  }) : _vm._e(), _vm._v(" "), _c("el-table-column", {
    attrs: {
      align: "center",
      prop: "phone_number",
      label: _vm.$t("table.mobile")
    }
  }), _vm._v(" "), _c("el-table-column", {
    attrs: {
      align: "center",
      prop: "area_code",
      label: "地区"
    }
  }), _vm._v(" "), _c("el-table-column", {
    attrs: {
      align: "center",
      prop: "city_name",
      label: _vm.$t("table.city")
    }
  }), _vm._v(" "), _c("el-table-column", {
    attrs: {
      align: "center",
      prop: "creator_username",
      label: _vm.$t("table.creator")
    }
  }), _vm._v(" "), _c("el-table-column", {
    attrs: {
      align: "center",
      prop: "bd_name",
      label: _vm.$t("table.bdName")
    }
  }), _vm._v(" "), !_vm.isBdRole ? _c("el-table-column", {
    attrs: {
      align: "center",
      prop: "is_modification_proportion",
      label: _vm.$t("table.isEditaArtistshare")
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref) {
        var row = _ref.row;
        return [_vm._v("\n        " + _vm._s(_vm._f("proportionFilter")(row.is_modification_proportion)) + "\n      ")];
      }
    }], null, false, 1803518050)
  }) : _vm._e(), _vm._v(" "), !_vm.isBdRole ? _c("el-table-column", {
    attrs: {
      align: "center",
      prop: "society_proportion",
      label: _vm.$t("table.unionShare")
    }
  }) : _vm._e(), _vm._v(" "), !_vm.isBdRole ? _c("el-table-column", {
    attrs: {
      align: "center",
      label: _vm.$t("table.brokerModel")
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref2) {
        var row = _ref2.row;
        return [_vm._v("\n        " + _vm._s(_vm._f("brokerModelFilter")(row.broker_model)) + "\n      ")];
      }
    }], null, false, 977165081)
  }) : _vm._e(), _vm._v(" "), _c("el-table-column", {
    attrs: {
      align: "center",
      label: _vm.$t("table.createdTime")
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref3) {
        var row = _ref3.row;
        return [_vm._v("\n        " + _vm._s(_vm._f("dateTimeFilter")(row.created_at, "yyyy-MM-dd hh:mm:ss")) + "\n      ")];
      }
    }])
  }), _vm._v(" "), _c("el-table-column", {
    attrs: {
      align: "center",
      prop: "STATUS",
      label: _vm.$t("table.status")
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref4) {
        var row = _ref4.row;
        return [_c("el-tag", {
          attrs: {
            type: row.STATUS !== 1 ? "danger" : ""
          }
        }, [_vm._v(_vm._s(_vm._f("statusFilter")(row.STATUS)))])];
      }
    }])
  }), _vm._v(" "), _c("el-table-column", {
    attrs: {
      align: "center",
      label: _vm.$t("table.operating")
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref5) {
        var row = _ref5.row;
        return [_c("el-button", {
          attrs: {
            type: "text"
          },
          on: {
            click: function click($event) {
              return _vm.handleDetail(row);
            }
          }
        }, [_vm._v("详情")]), _vm._v(" "), _c("el-button", {
          attrs: {
            type: "text"
          },
          on: {
            click: function click($event) {
              return _vm.goAnchorData(row);
            }
          }
        }, [_vm._v("旗下主播")]), _vm._v(" "), _c("el-button", {
          attrs: {
            type: "text"
          },
          on: {
            click: function click($event) {
              return _vm.goGuildData(row);
            }
          }
        }, [_vm._v("工会数据")]), _vm._v(" "), _vm.canEditBroker ? _c("el-button", {
          attrs: {
            type: "text"
          },
          on: {
            click: function click($event) {
              return _vm.handleEdit(row);
            }
          }
        }, [_vm._v(_vm._s(_vm.$t("table.edit")))]) : _vm._e(), _vm._v(" "), _vm.isAdminRole ? _c("el-button", {
          attrs: {
            type: "text"
          },
          on: {
            click: function click($event) {
              return _vm.handleStatus(row);
            }
          }
        }, [_vm._v(_vm._s(_vm.$t("table.delete")))]) : _vm._e(), _vm._v(" "), !_vm.isBdRole ? _c("el-button", {
          attrs: {
            type: "text"
          },
          on: {
            click: function click($event) {
              return _vm.$router.push("/broker/income/".concat(row.broker_id));
            }
          }
        }, [_vm._v(_vm._s(_vm.$t("table.brokerIncome")))]) : _vm._e()];
      }
    }])
  })], 1), _vm._v(" "), _c("el-dialog", {
    attrs: {
      visible: _vm.dialogVisible,
      title: _vm.dialogType === "edit" ? _vm.$t("table.editBroker") : _vm.$t("table.addBroker"),
      width: "550px"
    },
    on: {
      "update:visible": function updateVisible($event) {
        _vm.dialogVisible = $event;
      }
    }
  }, [_c("el-form", {
    ref: "editForm",
    attrs: {
      model: _vm.formData,
      rules: _vm.rules,
      "label-width": "80px"
    }
  }, [_vm.showCredentialFields ? _c("el-form-item", {
    attrs: {
      label: _vm.$t("table.invitationCode"),
      prop: "auth_code",
      required: ""
    }
  }, [_c("el-input", {
    attrs: {
      placeholder: _vm.$t("table.invitationCode")
    },
    model: {
      value: _vm.formData.auth_code,
      callback: function callback($$v) {
        _vm.$set(_vm.formData, "auth_code", $$v);
      },
      expression: "formData.auth_code"
    }
  })], 1) : _vm._e(), _vm._v(" "), _vm.showCredentialFields ? _c("el-form-item", {
    attrs: {
      label: _vm.$t("table.loginID"),
      prop: "broker_username",
      required: ""
    }
  }, [_c("el-input", {
    attrs: {
      placeholder: _vm.$t("table.loginID")
    },
    model: {
      value: _vm.formData.broker_username,
      callback: function callback($$v) {
        _vm.$set(_vm.formData, "broker_username", $$v);
      },
      expression: "formData.broker_username"
    }
  })], 1) : _vm._e(), _vm._v(" "), _vm.showCredentialFields ? _c("el-form-item", {
    attrs: {
      label: _vm.$t("table.password"),
      prop: "broker_psg",
      required: ""
    }
  }, [_c("el-input", {
    attrs: {
      placeholder: _vm.$t("table.password")
    },
    model: {
      value: _vm.formData.broker_psg,
      callback: function callback($$v) {
        _vm.$set(_vm.formData, "broker_psg", $$v);
      },
      expression: "formData.broker_psg"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c("el-form-item", {
    attrs: {
      label: _vm.$t("table.name"),
      prop: "name",
      required: ""
    }
  }, [_c("el-input", {
    attrs: {
      placeholder: _vm.$t("table.name")
    },
    model: {
      value: _vm.formData.name,
      callback: function callback($$v) {
        _vm.$set(_vm.formData, "name", $$v);
      },
      expression: "formData.name"
    }
  })], 1), _vm._v(" "), _c("el-form-item", {
    attrs: {
      label: _vm.$t("table.payType"),
      prop: "pay_type"
    }
  }, [_c("el-input", {
    attrs: {
      placeholder: _vm.$t("table.payType")
    },
    model: {
      value: _vm.formData.pay_type,
      callback: function callback($$v) {
        _vm.$set(_vm.formData, "pay_type", $$v);
      },
      expression: "formData.pay_type"
    }
  })], 1), _vm._v(" "), _c("el-form-item", {
    attrs: {
      label: _vm.$t("table.payAccount"),
      prop: "pay_account"
    }
  }, [_c("el-input", {
    attrs: {
      placeholder: _vm.$t("table.payAccount")
    },
    model: {
      value: _vm.formData.pay_account,
      callback: function callback($$v) {
        _vm.$set(_vm.formData, "pay_account", $$v);
      },
      expression: "formData.pay_account"
    }
  })], 1), _vm._v(" "), _c("el-form-item", {
    attrs: {
      label: _vm.$t("table.mobile"),
      prop: "phone_number",
      required: ""
    }
  }, [_c("el-input", {
    attrs: {
      placeholder: _vm.$t("table.mobile")
    },
    model: {
      value: _vm.formData.phone_number,
      callback: function callback($$v) {
        _vm.$set(_vm.formData, "phone_number", $$v);
      },
      expression: "formData.phone_number"
    }
  })], 1), _vm._v(" "), _c("el-form-item", {
    attrs: {
      label: "管辖区域",
      prop: "area_code",
      required: ""
    }
  }, [_c("el-select", {
    staticStyle: {
      width: "100%"
    },
    attrs: {
      multiple: "",
      filterable: "",
      clearable: "",
      placeholder: "请选择地区"
    },
    model: {
      value: _vm.formData.area_code,
      callback: function callback($$v) {
        _vm.$set(_vm.formData, "area_code", $$v);
      },
      expression: "formData.area_code"
    }
  }, _vm._l(_vm.areaCodeList, function (item) {
    return _c("el-option", {
      key: item.area_code,
      attrs: {
        label: item.area_code,
        value: item.area_code
      }
    });
  }), 1)], 1), _vm._v(" "), _c("el-form-item", {
    attrs: {
      label: _vm.$t("table.city"),
      prop: "city_name",
      required: ""
    }
  }, [_c("el-input", {
    attrs: {
      placeholder: _vm.$t("table.city")
    },
    model: {
      value: _vm.formData.city_name,
      callback: function callback($$v) {
        _vm.$set(_vm.formData, "city_name", $$v);
      },
      expression: "formData.city_name"
    }
  })], 1), _vm._v(" "), _c("el-form-item", {
    attrs: {
      label: _vm.$t("table.countryCode"),
      prop: "country_code",
      required: ""
    }
  }, [_c("el-input", {
    attrs: {
      placeholder: _vm.$t("table.countryCode")
    },
    model: {
      value: _vm.formData.country_code,
      callback: function callback($$v) {
        _vm.$set(_vm.formData, "country_code", $$v);
      },
      expression: "formData.country_code"
    }
  })], 1), _vm._v(" "), _vm.isAdminRole ? _c("el-form-item", {
    attrs: {
      label: "BD ID"
    }
  }, [_c("el-input", {
    attrs: {
      placeholder: "请输入BD ID",
      clearable: ""
    },
    model: {
      value: _vm.formData.bd_id,
      callback: function callback($$v) {
        _vm.$set(_vm.formData, "bd_id", $$v);
      },
      expression: "formData.bd_id"
    }
  })], 1) : _vm._e(), _vm._v(" "), !_vm.isBdRole ? _c("el-form-item", {
    attrs: {
      label: "主播单价"
    }
  }, [_c("el-input", {
    attrs: {
      placeholder: "主播单价"
    },
    model: {
      value: _vm.formData.anchor_unit_price,
      callback: function callback($$v) {
        _vm.$set(_vm.formData, "anchor_unit_price", $$v);
      },
      expression: "formData.anchor_unit_price"
    }
  })], 1) : _vm._e(), _vm._v(" "), !_vm.isBdRole ? _c("el-form-item", {
    attrs: {
      label: _vm.$t("table.brokerModel"),
      prop: "broker_model",
      required: ""
    }
  }, [_c("el-select", {
    attrs: {
      placeholder: "$t('table.brokerModel')"
    },
    model: {
      value: _vm.formData.broker_model,
      callback: function callback($$v) {
        _vm.$set(_vm.formData, "broker_model", $$v);
      },
      expression: "formData.broker_model"
    }
  }, [_c("el-option", {
    attrs: {
      label: "独立",
      value: 1
    }
  }), _vm._v(" "), _c("el-option", {
    attrs: {
      label: "推广",
      value: 2
    }
  })], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c("div", {
    staticStyle: {
      "text-align": "right"
    }
  }, [_c("el-button", {
    attrs: {
      type: "danger"
    },
    on: {
      click: function click($event) {
        _vm.dialogVisible = false;
      }
    }
  }, [_vm._v(_vm._s(this.$t("form.cancel")))]), _vm._v(" "), _c("el-button", {
    attrs: {
      type: "primary"
    },
    on: {
      click: _vm.confirm
    }
  }, [_vm._v(_vm._s(this.$t("form.confirm")))])], 1)], 1), _vm._v(" "), _c("el-dialog", {
    attrs: {
      visible: _vm.detailVisible,
      title: "公会详情",
      width: "80%",
      top: "5vh"
    },
    on: {
      "update:visible": function updateVisible($event) {
        _vm.detailVisible = $event;
      }
    }
  }, [_c("el-form", {
    staticClass: "detail-form",
    attrs: {
      "label-width": "120px"
    }
  }, [_c("el-row", {
    attrs: {
      gutter: 20
    }
  }, [_c("el-col", {
    attrs: {
      span: 8
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "公会名称"
    }
  }, [_vm._v(_vm._s(_vm.detailBroker.name || "-"))])], 1), _vm._v(" "), _c("el-col", {
    attrs: {
      span: 8
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "公会ID"
    }
  }, [_vm._v(_vm._s(_vm.detailBroker.broker_id || "-"))])], 1), _vm._v(" "), _c("el-col", {
    attrs: {
      span: 8
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "邀请码"
    }
  }, [_vm._v(_vm._s(_vm.detailBroker.auth_code || "-"))])], 1)], 1), _vm._v(" "), _c("el-row", {
    attrs: {
      gutter: 20
    }
  }, [_c("el-col", {
    attrs: {
      span: 8
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "主播数量"
    }
  }, [_vm._v(_vm._s(_vm.detailBroker.anchorCount || 0))])], 1), _vm._v(" "), _c("el-col", {
    attrs: {
      span: 8
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "手机号"
    }
  }, [_vm._v(_vm._s(_vm.detailBroker.phone_number || "-"))])], 1), _vm._v(" "), _c("el-col", {
    attrs: {
      span: 8
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "状态"
    }
  }, [_c("el-tag", {
    attrs: {
      type: _vm.detailBroker.STATUS !== 1 ? "danger" : ""
    }
  }, [_vm._v(_vm._s(_vm._f("statusFilter")(_vm.detailBroker.STATUS)))])], 1)], 1)], 1), _vm._v(" "), _c("el-row", {
    attrs: {
      gutter: 20
    }
  }, [_c("el-col", {
    attrs: {
      span: 8
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "管辖区域"
    }
  }, [_vm._v(_vm._s(_vm.detailBroker.area_code || "-"))])], 1), _vm._v(" "), _c("el-col", {
    attrs: {
      span: 8
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "城市"
    }
  }, [_vm._v(_vm._s(_vm.detailBroker.city_name || "-"))])], 1), _vm._v(" "), _c("el-col", {
    attrs: {
      span: 8
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "国家编码"
    }
  }, [_vm._v(_vm._s(_vm.detailBroker.country_code || "-"))])], 1)], 1), _vm._v(" "), _c("el-row", {
    attrs: {
      gutter: 20
    }
  }, [_c("el-col", {
    attrs: {
      span: 8
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "收款方式"
    }
  }, [_vm._v(_vm._s(_vm.detailBroker.pay_type || "-"))])], 1), _vm._v(" "), _c("el-col", {
    attrs: {
      span: 8
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "收款账号"
    }
  }, [_vm._v(_vm._s(_vm.detailBroker.pay_account || "-"))])], 1), _vm._v(" "), _c("el-col", {
    attrs: {
      span: 8
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "归属BD"
    }
  }, [_vm._v(_vm._s(_vm.detailBroker.bd_name || _vm.detailBroker.bd_id || "官方公会"))])], 1)], 1), _vm._v(" "), _c("el-row", {
    attrs: {
      gutter: 20
    }
  }, [!_vm.isBdRole ? _c("el-col", {
    attrs: {
      span: 8
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "登录ID"
    }
  }, [_vm._v(_vm._s(_vm.detailBroker.broker_username || "-"))])], 1) : _vm._e(), _vm._v(" "), !_vm.isBdRole ? _c("el-col", {
    attrs: {
      span: 8
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "公会模式"
    }
  }, [_vm._v(_vm._s(_vm._f("brokerModelFilter")(_vm.detailBroker.broker_model)))])], 1) : _vm._e(), _vm._v(" "), _c("el-col", {
    attrs: {
      span: 8
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "创建时间"
    }
  }, [_vm._v(_vm._s(_vm._f("dateTimeFilter")(_vm.detailBroker.created_at, "yyyy-MM-dd hh:mm:ss")))])], 1)], 1)], 1)], 1), _vm._v(" "), _c("pagination", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.total > 0,
      expression: "total>0"
    }],
    attrs: {
      total: _vm.total,
      page: _vm.listQuery.page,
      limit: _vm.listQuery.size
    },
    on: {
      "update:page": function updatePage($event) {
        return _vm.$set(_vm.listQuery, "page", $event);
      },
      "update:limit": function updateLimit($event) {
        return _vm.$set(_vm.listQuery, "size", $event);
      },
      pagination: _vm.getList
    }
  })], 1);
};
var staticRenderFns = exports.staticRenderFns = [];
render._withStripped = true;